export default "__VITE_ASSET__Cb8RN4B7__"